import React from 'react';

import { PhotoIcon, StyledButton } from './styles';

export const UploadPlaceholder = (): JSX.Element => {
  return (
    <StyledButton id="preview-photo-walkthrough">
      <PhotoIcon width={24} height={24} />
      Preview with your photo
    </StyledButton>
  );
};

export default UploadPlaceholder;
